<template>
  <div>
  <b-modal ref="modal-payment-partial" hide-footer size="md" title="¿Estás seguro(a) que deseas realizar el pago parcial?">
      <b-row class="mt-4 mb-2">
        <b-col md="12">
          <b-form-group label="Selecciona método de pago" class="text-center" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="selectedPaymentMethod"
              button-variant="outline-info"
              buttons
              pill
              class="w-200"
              size="lg"
            >
             <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="PAYNET" style="width: 25%;">
                <span class="fa-solid fa-store fa-1x"></span>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">PAYNET</p>
             </b-form-radio>
             <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="OXXO" style="width: 25%;">
                <span class="fa-solid fa-store fa-1x"></span>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Oxxo</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="CASH" style="width: 25%;">
                <i class="fa-solid fa-money-bill-wave fa-1x"></i>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Efectivo</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="TRANSF" style="width: 25%;">
                <i class="fa-solid fa-coins fa-1x"></i>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Transferencia</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="TB" style="width: 25%;">
                <i class="fa-solid fa-check-to-slot fa-1x"></i>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Terminal</p>
              </b-form-radio>
          </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col md="8" offset="2" v-if="selectedPaymentMethod==='TRANSF'">
          <div class="form-group mb-3">
            <label># Referencia</label>
            <input type="text" class="form-control" v-model="transferNo">
          </div>
        </b-col>
        <b-col md="8" offset="2" v-if="selectedPaymentMethod==='TB'">
          <div class="form-group mb-3">
            <label># Referencia</label>
            <input type="text" class="form-control" v-model="transferNo">
          </div>
        </b-col>
        <b-col md="12" v-if="selectedPaymentMethod === 'PAYNET' || selectedPaymentMethod === 'CASH' || selectedPaymentMethod==='OXXO' || selectedPaymentMethod==='TRANSF' || selectedPaymentMethod==='TB'">
         <div class="col-md-6" v-if="selectedPaymentMethod !== 'PAYNET'">
            <a-form-item
              label="Fecha de pago"
              has-feedback>
              <a-date-picker placeholder="Seleccionar fecha" @change="changePaymentDate" v-model="paymentDate" style="width: 100%" />
              <small class="text-danger" v-if="(paymentDate === null)">La fecha de pago no puede estar vacía</small>
            </a-form-item>
          </div>
          <div class="form-group mb-3">
            <b-table
                  show-empty
                  hover
                  stacked="sm"
                  :items="this.selectedObject"
                  :fields="fieldsPayment"
                  class="mb-0 bg-white"
                  empty-text="No hay pagos por mostrar"
                  emptyFilteredText="No existen registros por mostrar"
                >
                <template v-slot:cell(numConcesion)="row">
                  {{ row.item.numConcesion }}
                </template>
                <template v-slot:cell(periodos)="row">
                  {{ row.item.periodos }}
                </template>
                <template v-slot:cell(total)="row">
                  <input v-bind:style="{width: '65px'}" type='number' min='0' :max='row.item.periodos.length' step='1' class="form-control" v-model="numPeriods[row.index]"  @input="() => { if(numPeriods[row.index] > row.item.periodos.length || numPeriods[row.index] < 1) { numPeriods[row.index] = row.item.periodos.length }}"  :state="validateMaxPeriods(row.item.periodos.length, row.index, 1)">
                </template>
            </b-table>
          </div>
          <div class="col-md-12">
            <b-col class="text-right" sm="2" md="10">
              <p id="cuantity" class="mb-0">Cantidad a Pagar: <b> ${{ totalAmountModal() }}</b></p>
            </b-col>
          </div>
          <div class="col-md-12">
            <span></span>
          </div>
        </b-col>
        <b-col md="8" offset="2">
          <b-button
            variant="success"
            block
            pill
            size="lg"
            :disabled="!(selected.length > 0) || !(validNumPayments) || pagando"
            @click="pagosParciales(1)"
          >
            <b-spinner v-if="pagando" small variant="white" label="Spinning" class="fix-position mr-2"></b-spinner>
            Pagar
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="modal-payment" hide-footer size="md" title="¿Estás seguro(a) que deseas realizar el pago?">
      <b-row class="mt-4 mb-2">
        <b-col md="10" offset="1">
          <b-form-group label="Selecciona método de pago" class="text-center" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="selectedPaymentMethod"
              button-variant="outline-info"
              buttons
              pill
              class="w-100"
              size="lg"
            >
             <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="PAYNET" style="width: 25%;">
                <span class="fa-solid fa-store fa-1x"></span>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">PAYNET</p>
             </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="OXXO" style="width: 25%;">
                <span class="fa-solid fa-store fa-1x"></span>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Oxxo</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="CASH" style="width: 25%;">
                <i class="fa-solid fa-money-bill-wave fa-1x"></i>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Efectivo</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="TRANSF" style="width: 25%;">
                <i class="fa-solid fa-coins fa-1x"></i>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Transferencia</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="TB" style="width: 25%;">
                <i class="fa-solid fa-check-to-slot fa-1x"></i>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Terminal</p>
              </b-form-radio>
          </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col md="8" offset="2" v-if="selectedPaymentMethod==='TRANSF'">
          <div class="form-group mb-3">
            <label># Referencia</label>
            <input type="text" class="form-control" v-model="transferNo">
          </div>
        </b-col>
        <b-col md="8" offset="2" v-if="selectedPaymentMethod==='TB'">
          <div class="form-group mb-3">
            <label># Referencia</label>
            <input type="text" class="form-control" v-model="transferNo">
          </div>
        </b-col>
        <b-col md="8" offset="2">
          <b-button
            variant="success"
            block
            pill
            size="lg"
            :disabled="!(selected.length > 0) || pagando || selectedPaymentMethod === null"
            @click="payConcessions"
          >
            <b-spinner v-if="pagando" small variant="white" label="Spinning" class="fix-position mr-2"></b-spinner>
            Pagar
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="modal-payment-future" hide-footer size="md" title="¿Estás seguro(a) que deseas realizar el pago adelantado?">
      <b-row class="mt-4 mb-2">
        <b-col md="12">
          <b-form-group label="Selecciona método de pago" class="text-center" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="selectedPaymentMethod"
              button-variant="outline-info"
              buttons
              pill
              class="w-200"
              size="lg"
            >
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="PAYNET" style="width: 25%;">
                  <span class="fa-solid fa-store fa-1x"></span>
                  <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">PAYNET</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="OXXO" style="width: 25%;">
                <span class="fa-solid fa-store fa-1x"></span>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Oxxo</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="CASH" style="width: 25%;">
                <i class="fa-solid fa-money-bill-wave fa-1x"></i>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Efectivo</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="TRANSF" style="width: 25%;">
                <i class="fa-solid fa-coins fa-1x"></i>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Transferencia</p>
              </b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" class="mb-2 pt-3" value="TB" style="width: 25%;">
                <i class="fa-solid fa-check-to-slot fa-1x"></i>
                <p class="mt-1 mb-0" style="line-height: 1; font-size: 13px;">Terminal</p>
              </b-form-radio>
          </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col md="8" offset="2" v-if="selectedPaymentMethod==='TRANSF'">
          <div class="form-group mb-3">
            <label># Referencia</label>
            <input type="text" class="form-control" v-model="transferNo">
          </div>
        </b-col>
        <b-col md="8" offset="2" v-if="selectedPaymentMethod==='TB'">
          <div class="form-group mb-3">
            <label># Referencia</label>
            <input type="text" class="form-control" v-model="transferNo">
          </div>
        </b-col>
        <b-col md="10" offset="1"  v-if="selectedPaymentMethod === 'PAYNET' ||  selectedPaymentMethod === 'CASH' || selectedPaymentMethod==='OXXO' || selectedPaymentMethod==='TRANSF' || selectedPaymentMethod==='TB'">
          <div class="form-group mb-3" v-if="selectedPaymentMethod !== 'PAYNET'">
            <a-form-item
              label="Fecha de pago"
              has-feedback>
              <a-date-picker placeholder="Seleccionar fecha" @change="changePaymentDate" v-model="paymentDate" style="width: 100%" />
              <small class="text-danger" v-if="(paymentDate === null)">La fecha de pago no puede estar vacía</small>
            </a-form-item>
          </div>
          <div class="form-group mb-3">
            <b-row v-if="!$apollo.loading">
              <b-form-group label="Selecciona las concesiones a pagar" v-slot="{ ariaDescribedby }" class="w-100 mb-0">
                <b-form-checkbox-group
                  id="checkbox-group-2"
                  v-model="selectedConcesions"
                  @change="selectedConcesionUpdate"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2"
                >
                  <b-table
                    show-empty
                    hover
                    stacked="md"
                    :items="allConcesions"
                    :fields="fieldsConcesions"
                    :current-page="currentPage"
                    :per-page="perPage"
                    class="mb-0 bg-white"
                    empty-text="No existen registros por mostrar"
                    emptyFilteredText="No existen registros por mostrar"
                  >
                  <template v-slot:cell(concesionNumber)="row">
                      <b-form-checkbox :value="row.item.concesionNumber">{{row.item.concesionNumber}}</b-form-checkbox>
                    </template>
                  <template v-slot:cell(total)="row">
                    <input v-bind:style="{width: '65px'}" type='number' min='0' :max='12' step='1' class="form-control" v-model="numPeriods[row.index]"  @input="() => { if(numPeriods[row.index] > 12|| numPeriods[row.index] < 1) { numPeriods[row.index] = 12 }}"  :state="validateMaxPeriods(12, row.index, 2)">
                  </template>
                  </b-table>
                </b-form-checkbox-group>
              </b-form-group>
            </b-row>
          </div>
          <div class="col-md-12">
            <b-col class="text-right" sm="2" md="10">
              <p id="cuantity" class="mb-0">Cantidad a Pagar: <b> ${{ totalAmountModal() }}</b></p>
            </b-col>
          </div>
          <div class="col-md-12">
            <span></span>
          </div>
        </b-col>
        <b-col md="8" offset="2">
          <b-button
            variant="success"
            block
            pill
            size="lg"
            :disabled="!(validNumPayments) || pagando || (selectedConcesions.length === 0)"
            @click="pagosParciales(2)"
          >
            <b-spinner v-if="pagando" small variant="white" type="grow"></b-spinner>
            Pagar
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-row class="mb-3">
      <b-col md="8">
        <h1><b>Pagos concesionario</b> <b-badge pill class="ml-1 mt-0 pt-2" :class="this.$route.params.active === 1 ? 'bg-success' : 'bg-danger'">{{this.$route.params.active === 1 ? 'Activo' : 'Inactivo'}}</b-badge></h1>
      </b-col>
      <b-col md="4" class="text-right mt-1">
        <router-link to="/historialPagos/concesionarios"><b-button class="text-right" pill size="lg" variant="outline-info">Regresar</b-button></router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card class="bg-light">
          <b-row>
            <b-col md="6">
              <label class="mb-0">Concesionario</label>
              <h3 class="text-dark mb-1">{{this.$route.params.name}}</h3>
              <h5 class="muted">{{this.$route.params.rfc}} <b-badge variant="secondary" size="md" class="mr-2 mt-0">{{this.$route.params.id}}</b-badge></h5>
              <!--label class="mb-0">RFC</!--label>
              <h4 class="text-dark">{{this.$route.params.rfc}}</h4 -->
            </b-col>
            <b-col md="6">
              <label class="mb-0">Resumen</label>
              <div class="clearfix"></div>
              <h5 class="text-dark mb-0">{{this.$route.params.email}}</h5>
              <h5 class="muted mb-0">{{this.$route.params.phoneNumber}}</h5>
              <h5 class="muted">{{this.$route.params.address.postalCode}} - {{this.$route.params.address.city}}</h5>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card no-body class="bg-light">
          <b-card-header>
            <h3 class="mb-0"><b>Cuentas por pagar</b></h3>
          </b-card-header>
          <b-card-body class="pl-3 pr-3 pt-0 pb-0">
            <div class="text-center pt-3 pb-3" v-if="$apollo.loading">
              <b-spinner variant="info" label="Spinning">Cargando</b-spinner>
            </div>
            <b-row v-if="!$apollo.loading">
              <b-form-group v-slot="{ ariaDescribedby }" class="w-100 mb-0">
                <b-form-checkbox-group
                  id="checkbox-group-2"
                  v-model="selected"
                  @change="selectedObjectUpdate"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2"
                >
                  <b-table
                    show-empty
                    hover
                    stacked="md"
                    :items="getOrderPayment"
                    :fields="fieldsCash"
                    :current-page="currentPagePays"
                    :per-page="12"
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFilteredOrders"
                    class="mb-0 bg-white"
                    empty-text="No existen registros por mostrar"
                    emptyFilteredText="No existen registros por mostrar"
                  >
                    <template v-slot:cell(amount)="row">
                      {{ '$' + row.item.amount + ' MXN' }}
                    </template>
                    <template v-slot:cell(tempVerification)="row">
                        <template v-if="row.item.tempVerification == undefined">
                      </template>
                      <template v-else>
                          <div :class="statusDictionary[row.item.tempVerification].class">{{ statusDictionary[row.item.tempVerification].label }}</div>
                      </template>
                    </template>
                    <template v-slot:cell(acciones)="row">
                      <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                        {{ row.detailsShowing ? 'Cerrar' : 'Ver'}} Detalles
                      </b-button>
                    </template>
                    <template v-slot:cell(id)="row">
                      <b-form-checkbox :value="row.item.numConcesion"></b-form-checkbox>
                    </template>

                    <template v-slot:cell(vehicleBrand)="row">
                      <div v-if="row.item.vehicle">
                        {{ row.item.vehicle.brand + ' ' + row.item.vehicle.model }}
                      </div>
                    </template>
                    <template v-slot:cell(licensePlate)="row">
                      <div v-if="row.item.vehicle">
                        {{ row.item.vehicle.licensePlate }}
                      </div>
                    </template>

                    <template #row-details="row">
                      <b-table
                        :items="row.item.periodos"
                        small
                        borderless
                        :fields="['periodos']"
                        >
                        <template v-slot:cell(periodos)="row">
                          {{ row.item }}
                        </template>
                      </b-table>
                    </template>
                  </b-table>
                </b-form-checkbox-group>
              </b-form-group>
            </b-row>
          </b-card-body>
          <b-card-footer class="pb-2 bg-light">
            <b-row class="mb-2">
              <hr>
              <b-col class="text-right mt-2" sm="2" md="9">
                  <p id="cuantity" class="mb-0">Cantidad a Pagar: <b> ${{ total() }}</b></p>
                </b-col>
              <b-col md="3">
                <b-button
                  variant="outline-success"
                  block
                  pill
                  size="lg"
                  :disabled="!(selected.length > 0) || pagando"
                  @click="showModal"
                >
                  <b-spinner v-if="pagando" small variant="success" label="Spinning" class="fix-position mr-2"></b-spinner>
                  Pago Total
                </b-button>
                 <b-button
                  variant="outline-info"
                  block
                  pill
                  size="lg"
                  :disabled="!(selected.length > 0) || pagando"
                  @click="showModalPartial"
                >
                <b-spinner v-if="pagando" small variant="success" label="Spinning" class="fix-position mr-2"></b-spinner>
                  Pago Parcial
                </b-button>
                <b-button
                  variant="outline-info"
                  block
                  pill
                  size="lg"
                  :disabled="!(allConcesions.length > 0) || pagando"
                  @click="showModalFuture"
                >
                  <b-spinner v-if="pagando" small variant="success" label="Spinning" class="fix-position mr-2"></b-spinner>
                  Pago Adelantado
                </b-button>
              </b-col>
            </b-row>
            <b-card-footer class="pb-2">
            <b-pagination
              v-model="currentPagePays"
              :total-rows="totalRowsOrders"
              align="right"
              :per-page="12"
              class="my-0"
            ></b-pagination>
          </b-card-footer>
        </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card no-body class="bg-light">
          <b-card-header class="pb-0">
            <b-row>
              <b-col md="8" class="my-1">
                <h3><b>Historial de pagos</b></h3>
              </b-col>
              <b-col md="4" class="my-1">
                <b-form-group>
                  <b-input-group>
                    <b-form-input v-model="filter" class="form-control" placeholder="Filtrar"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
                    </b-input-group-append>
                  </b-input-group>
                <!-- b-col md="6">
                  <a-month-picker :disabled-date="disabledDate" @change="changePeriod" :v-model="periodo" class="form-control w-75" placeholder="Seleccionar periodo" />
                  <b-button @click="searchPaymentByPeriod()">Buscar</b-button>
                </!-->
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="pl-0 pr-0 pt-0 pb-0">
            <b-row>
              <b-col md="12">
                <div class="text-center pt-3 pb-3" v-if="$apollo.loading">
                  <b-spinner variant="info" label="Spinning">Cargando</b-spinner>
                </div>
                <b-table
                  show-empty
                  hover
                  stacked="sm"
                  :items="getPaymentsHistory"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                  class="mb-0 bg-white"
                  empty-text="No hay pagos por mostrar"
                  emptyFilteredText="No existen registros por mostrar"
                  v-if="!$apollo.loading"
                >
                  <template v-slot:cell(amount)="row">
                    {{ '$'+ row.item.amount }}
                  </template>
                  <template v-slot:cell(concesiones)="row">
                    <!-- {{ row.item.periodo }} -->
                    <template v-if="row.item.concesiones[0].periodos !==undefined">
                      {{ allperiodos( row.item.concesiones[0].periodos) }}
                    </template>
                  </template>
                  <template v-slot:cell(acciones)="row" class="text-right">
                    <a @click="row.toggleDetails"><u>{{ row.detailsShowing ? 'Cerrar' : 'Ver'}} Detalles <span class="fa-solid fa-sm ml-2" :class="row.detailsShowing ? 'fa-chevron-up' : 'fa-chevron-down' "></span></u></a>
                  </template>
                  <template #row-details="row" no-body>
                    <b-row class="bg-light ml-0 pl-0 mr-0">
                      <b-col md="7">
                        <b-table
                          :items="row.item.concesiones"
                          small
                          borderless
                          class="bg-light"
                          :fields="[
                            { key: 'concesionNumber', label: 'Concesión' },
                            { key: 'amount', label: 'Monto' }
                          ]"
                          >
                          <template v-slot:cell(amount)="row">
                            {{ '$'+ row.item.amount }}
                          </template>
                        </b-table>
                      </b-col>
                      <b-col md="5" class="pt-4 text-right">
                        <b-button :disabled="cancelingPayment" variant="outline-info" v-if="row.item.status === 'PENDING_OXXO'" @click="viewPaymentInvoice(row.item.paymentURL)">
                          <span class="fa-solid fa-square-up-right mr-2"></span>
                          Referencia de pago
                        </b-button>
                        <b-button :disabled="cancelingPayment" variant="outline-danger" v-if="row.item.status === 'PENDING_OXXO'" @click="cancelPayment(row.item.pk, row.item.idTransaction)" class="ml-2">
                          <b-spinner v-if="cancelingPayment" small label="Spinning" class="fix-position mt-2"></b-spinner>
                          <span v-if="!cancelingPayment" class="fa-solid fa-trash-can mr-2"></span>
                          Cancelar Pago
                        </b-button>
                        <b-button :disabled="cancelingPayment" variant="outline-info" v-if="row.item.status === 'PENDING_OPENPAY'" @click="viewPaymentInvoice(row.item.paymentURL)">
                          <span class="fa-solid fa-square-up-right mr-2"></span>
                          Referencia de pago
                        </b-button>
                        <b-button :disabled="cancelingPayment" variant="outline-danger" v-if="row.item.status === 'PENDING_OPENPAY'" @click="cancelPayment(row.item.pk, row.item.idTransaction)" class="ml-2">
                          <b-spinner v-if="cancelingPayment" small label="Spinning" class="fix-position mt-2"></b-spinner>
                          <span v-if="!cancelingPayment" class="fa-solid fa-trash-can mr-2"></span>
                          Cancelar Pago
                        </b-button>
                      </b-col>
                    </b-row>
                  </template>
                  <template v-slot:cell(status)="row">
                    <div :class="statusDictionary[row.item.status].class">{{ statusDictionary[row.item.status].label }}</div>
                  </template>
                  <template v-slot:cell(periodos)="row">
                    {{ replaceMonth(row.item.concesiones[0].periodos[row.item.concesiones[0].periodos.length - 1]) }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-card-body>
          <b-card-footer class="pb-2">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              align="right"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import * as secrets from '@/services/secrets'
import moment from 'moment'
import headers from '@/config/headers.js'
import crypto from 'crypto-js'
import { notification } from 'ant-design-vue'
import config from '../../../../environment.json'
import axios from 'axios'
const GET_PAYMENT_HISTORY = gql`
  query getPaymentsHistory($rfc: String){
    getPaymentsHistory(rfc: $rfc) {
      paidBy
      paymentDate
      createdAt
      pk
      type
      idTransaction
      paymentURL
      concesiones{
        periodos
        concesionNumber
        amount
      }
      status
      successful
      amount
    }
  }
`
const GET_PAYMENT_HISTORY_BY_PERIOD = gql`
  query getPaymentsHistoryByPeriod($rfc: String, $periodo: String){
    getPaymentsHistoryByPeriod(rfc: $rfc periodo: $periodo){
      paidBy
      paymentDate
      type
      concesiones{
        periodos
        concesionNumber
        amount
     }
     idTransaction
     transaction
     requestID
     paymentURL
     amount
     successful
     status
    }
  }
`
const CANCEL_PAYMENT = gql`
  mutation cancelTransaction($cancelTransactionInput: cancelTransactionInput) {
    cancelTransaction(cancelTransactionInput: $cancelTransactionInput) {
      message
    }
  }
`
const GET_AUTH_PAYMENTS = gql`
  query getAuthPayments ($rfc: String) {
    getAuthPayments (rfc: $rfc) {
      pendingPayments
    }  
  }
`
const GENERATE_OXXO_PAYMENT = gql`
  mutation generateOxxoPaymentSub($paymentOxxoSubInput: paymentOxxoSubInput) {
    generateOxxoPaymentSub(paymentOxxoSubInput: $paymentOxxoSubInput) {
      pk,
      sk,
      paymentURL
    }
  }
`
const GENERATE_CASH_PAYMENT = gql`
  mutation generateCashPayment($paymentCashInput: paymentCashInput) {
    generateCashPayment(paymentCashInput: $paymentCashInput) {
      pk,
      sk
    }
  }
`
const GENERATE_TRANSFER_PAYMENT = gql`
  mutation generateTransferPayment($paymentTransferInput: paymentTransferInput) {
    generateTransferPayment(paymentTransferInput: $paymentTransferInput) {
      pk,
      sk
    }
  }
`
const ACTIVATE_PAID_CONCESION = gql`
  mutation activatePaidConcesion($concesionNumber: String) {
    activatePaidConcesion(concesionNumber: $concesionNumber) {
      message
      __typename
    }
  }
`
const PAID_BY_PERIOD = gql`
  mutation paidByPeriod($paymentPeriodInput: PaymentPeriodInput) {
    paidByPeriod(paymentPeriodInput: $paymentPeriodInput) {
      message
      success
      transaction {
        rfc
        amount
        paymentDate
        type
        systemUser
        concesiones {
          periodos
          concesionNumber
          amount
          __typename
        }
     }
      __typename
    }
  }
`
const CREATE_TRX = gql`
  mutation paymentsCreateTrx($createTrxInput: CreateTrxInput) {
    paymentsCreateTrx(createTrxInput: $createTrxInput) {
      message
      success
      refNumber
      __typename
    }
  }
`
const CREATE_SUBSCRIBE = gql`
  mutation openpaySubscribe($oPSubscribeInput: OPSubscribeInput) {
    openpaySubscribe(oPSubscribeInput: $oPSubscribeInput) {
      message
      success
      jwt
      __typename
    }
  }
`
const GET_CONCESIONARIO_BY_ID = gql`
  query getConcesionarioId($id: Int) {
    getConcesionarioId(id: $id){
      id
      name
      automaticPayment
      cardId
      phoneNumber
      address {
        state
        city
        postalCode
        street
        suburb
        extNumber
        intNumber
      }
    }
  }
`
const GET_CONCESIONES_BY_CONCESIONARIO = gql`
  query($id: Int){
    getConcesionByConcesionario(id: $id){
      id
      concesionarioId
      concesionNumber
      createdAt
      updatedAt
      active
      paidOut
      status
      geofenceId
      temporaryVerification
      preferential
      siteId
    }
  }
`
export default {
  data() {
    return {
      rfc: this.$route.params.rfc,
      fields: [
        { key: 'paymentDate', label: 'Fecha de pago' },
        { key: 'idTransaction', label: 'ID Transacción' },
        { key: 'amount', label: 'Monto' },
        { key: 'type', label: 'Método' },
        { key: 'concesiones', label: 'Periodo(s)' },
        { key: 'paidBy', label: 'Responsable de Pago' },
        { key: 'status', label: 'Estado' },
        'acciones',
      ],
      fieldsCash: [
        { key: 'id', label: ' ' },
        { key: 'pk', label: 'RFC' },
        { key: 'numConcesion', label: '# Concesión', sortable: true, sortDirection: 'desc' },
        { key: 'vehicleBrand', label: 'Vehiculo' },
        { key: 'licensePlate', label: 'Placa' },
        { key: 'periodos', label: 'Periodos' },
        { key: 'amount', label: 'Monto' },
        // { key: 'tempVerification', label: 'Estado del pago' },
        // 'acciones',
        //  { key: 'vehicle.brand', label: 'Marca Vehículo' },
        //  { key: 'vehicle.serialNumber', label: 'Número de Serie' },
      ],
      fieldsPayment: [
        // 'index',
        { key: 'numConcesion', label: '# Concesión' },
        { key: 'periodos', label: 'Periodos' },
        { key: 'total', label: '# Pagos' },
      ],
      fieldsConcesions: [
        // 'index',
        { key: 'concesionNumber', label: '# Concesión' },
        { key: 'total', label: '# Pagos' },
      ],
      concesionario: {},
      errorMessage: '',
      totalRows: 1,
      currentPage: 1,
      totalRowsOrders: 1,
      currentPagePays: 1,
      perPage: 30,
      pagando: false,
      cancelingPayment: false,
      pageOptions: [5, 10, 15],
      sortBy: 'paymentDate',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      cardId: null,
      totalAmount: 0,
      idConcesionAction: null,
      dataLoad: -1,
      selectedPaymentMethod: 'CARD',
      toggleDataOXXO: false,
      selected: [],
      selectedObject: [],
      getPaymentsHistory: [],
      getOrderPayment: [],
      periodo: {},
      transferNo: '',
      numPeriods: [],
      allConcesions: [],
      allOrderPayment: [],
      selectedConcesions: [],
      selectedConcesionsObj: [],
      totalNumberPaid: 0,
      paymentDate: moment(new Date()).format('YYYY-MM-DD'),
      validNumPayments: false,
      months: {
        1: 'Enero',
        2: 'Febrero',
        3: 'Marzo',
        4: 'Abril',
        5: 'Mayo',
        6: 'Junio',
        7: 'Julio',
        8: 'Agosto',
        9: 'Septiembre',
        10: 'Octubre',
        11: 'Noviembre',
        12: 'Diciembre',
      },
      statusDictionary: {
        ACCEPTED_COMPLETED: { label: 'Pago exitoso', class: 'text-success font-weight-bold' },
        PENDING_CONFIRMATION: { label: 'Pendiente de confirmación', class: 'text-warning font-weight-bold' },
        PENDING_AUTH: { label: 'Autenticando...', class: 'text-warning font-weight-bold' },
        AUTH_REQUIRED: { label: 'Autorización requerida', class: 'text-warning font-weight-bold' },
        ACCEPTED_PROCESSING: { label: 'Pago aceptado (Procesando...)', class: 'text-warning font-weight-bold' },
        FAILED_REJECTED: { label: 'Pago fallido', class: 'text-danger font-weight-bold' },
        FAILED_EXPIRED: { label: 'Pago expirado', class: 'text-danger font-weight-bold' },
        FAILED_CANCELLED_BY_USER: { label: 'Pago cancelado', class: 'text-danger font-weight-bold' },
        FAILED_CANCELLED_BY_USER_AUTH: { label: 'Pago cancelado', class: 'text-danger font-weight-bold' },
        PENDING_RECEIVED: { label: 'Procesando pago...', class: 'text-warning font-weight-bold' },
        PENDING_OXXO: { label: 'Pendiente de pago', class: 'text-warning font-weight-bold' },
        PENDING_OPENPAY: { label: 'Pendiente de pago', class: 'text-warning font-weight-bold' },
      },
    }
  },
  apollo: {
    getOrderPayment: {
      query: gql`query getOrderPayment ($rfc: String) {
          getOrderPayment (rfc: $rfc) {
            numConcesion
            amount
            periodos
            tempVerification
            vehicle {
              licensePlate
              brand
              model
            }
            pk
            sk
          }
        }`,
      context: headers(),
      variables () {
        return {
          rfc: this.rfc,
        }
      },
      error (erro) {
        console.log('Ocurrió un error')
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        // console.log(this.dataLoad)
        // console.log('getOrderPayment', data)
        if (data.getOrderPayment) {
          this.totalRowsOrders = data.getOrderPayment.length
          this.allOrderPayment = data.getOrderPayment.map(c => {
            return c.numConcesion
          })
          console.log('Entraaaa')
          console.log(this.allOrderPayment)
          this.$apollo.queries.getConcesionByConcesionario.refetch()
        }
      },
    },
    getPaymentsHistory: {
      query: GET_PAYMENT_HISTORY,
      context: headers(),
      variables() {
        return {
          rfc: this.rfc,
        }
      },
      result({ data }) {
        // console.log('PARAMS ====> ', this.$route.params)
        // console.log('DATA ===> ', data.getPaymentsHistory)
        if (data.getPaymentsHistory) {
          this.totalRows = data.getPaymentsHistory.length
        }
        this.totalAmount = 1000
      },
      error(error) {
        console.log(error)
      },
    },
    getConcesionByConcesionario: {
      query: GET_CONCESIONES_BY_CONCESIONARIO,
      context: headers(),
      variables () {
        return {
          id: this.concesionario.id,
        }
      },
      error (e) {
        console.log('Ocurrió un error')
        console.log(e)
      },
      result ({ data, loading, networkStatus }) {
        console.log('concesionario ' + this.concesionario.id)
        // console.log(this.dataLoad)
        console.log('getAllConcesions', data)
        if (data.getConcesionByConcesionario) {
          let idx = 0
          this.allConcesions = data.getConcesionByConcesionario.filter(c => {
            if (this.allOrderPayment.indexOf(c.concesionNumber) === -1 && c.active === 1) {
              c.index = idx++
              return true
            }
            return false
          })
          console.log('All Concesions')
          console.log(this.allConcesions)
        }
        return this.allConcesions
      },
    },
  },
  async mounted() {
    try {
      if (this.$route.params) {
        this.concesionario = this.$route.params
        return
      } else {
        const concesionario = await this.$apollo.query({ query: GET_CONCESIONARIO_BY_ID, context: headers(), variables: { id: parseInt(this.$route.params.id) } })
        if (concesionario) {
          this.concesionario = concesionario.data.getConcesionarioById
        } else {
          return
        }
      }
    } catch (error) {
      console.log('ERROR ====> ', error)
    }
  },
  methods: {
    cancelPayment(rfc, idTransaction) {
      this.autoRefresh = false
      this.cancelingPayment = true
      const cancelT = {
        rfc: rfc,
        transactionId: idTransaction,
      }
      this.$apollo.mutate({
        mutation: CANCEL_PAYMENT,
        context: headers(),
        variables: {
          cancelTransactionInput: cancelT,
        },
      }).then(data => {
        this.autoRefresh = true
        const cancelMessage = data.data.cancelTransaction.message.split(':')[0]
        // const message = cancelMessage === 'SUCCESS' ? 'Pago cancelado con éxito' : 'No fue posible cancelar tu pago'
        if (cancelMessage === 'SUCCESS') {
          notification.success({
            message: 'Éxito',
            description: 'Pago cancelado con éxito',
          })
        } else {
          notification.error({
            message: 'Ocurrió un error',
            description: 'No fue posible cancelar tu pago',
          })
        }
        this.$apollo.queries.getPaymentsHistory.refetch()
        this.$apollo.queries.getOrderPayment.refetch()
        //
        this.cancelingPayment = false
      }).catch(e => {
        // console.log(e)
        notification.error({
          message: 'Ocurrió un error interno',
          description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #315',
        })
        this.cancelingPayment = false
      })
    },
    total() {
      // console.log(this.selectedObject)
      if (!this.selectedObject) return 0
      return this.selectedObject.map(el => el.amount).reduce((a, b) => a + b, 0)
    },
    selectedObjectUpdate() {
      this.selectedObject = []
      // console.log(this.getOrderPayment)
      setTimeout(() => {
        this.getOrderPayment.forEach(order => {
          if (this.selected.includes(order.numConcesion)) {
            this.selectedObject.push(order)
            this.total()
          }
        })
      }, 50)
    },
    selectedConcesionUpdate() {
      this.selectedConcesionsObj = []
      setTimeout(() => {
        this.getConcesionByConcesionario.forEach(c => {
          if (this.selectedConcesions.includes(c.concesionNumber)) {
            console.log(c)
            this.selectedConcesionsObj.push(c)
          }
        })
        console.log(this.selectedConcesions)
      }, 50)
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onFilteredOrders(filteredItems) {
      this.totalRowsOrders = filteredItems.length
      this.currentPagePays = 1
    },
    disabledDate(current) {
      return current > moment().add(1, 'days')
    },
    viewPaymentInvoice(paymentURL) {
      window.open(paymentURL, '_blank')
    },
    replaceMonth(date) {
      console.log('replacemonth => ', date)
      const month = this.months[date.split('-')[1]]
      const newDate = date.split('-')[0] + '-' + month
      return newDate
    },
    searchPaymentByPeriod() {
      if (this.periodo === '' || typeof (this.periodo) === 'object') {
        this.$apollo.queries.getPaymentsHistory.refetch()
        this.$apollo.queries.getOrderPayment.refetch()
      } else {
        this.$apollo.query({
          query: GET_PAYMENT_HISTORY_BY_PERIOD,
          context: headers(),
          variables: {
            rfc: this.rfc,
            periodo: String(this.periodo),
          },
        })
          .then(({ data }) => {
            if (data.getPaymentsHistoryByPeriod) {
              // console.log(data)
              this.getPaymentsHistory = data.getPaymentsHistoryByPeriod
              this.totalRows = data.getPaymentsHistoryByPeriod.length
            } else {
              // this.$apollo.queries.getPaymentsHistory.refetch()
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    changePeriod(event) {
      this.periodo = event ? moment(new Date(event._d)).format('YYYY-M') : ''
    },
    allperiodos(array) {
      var periodostotal = ''
      array.forEach((element, i) => {
        periodostotal = i === 0 ? periodostotal + element : periodostotal + ',  ' + element
      })
      return periodostotal
    },
    showModal() {
      this.selectedPaymentMethod = null
      this.transferNo = ''
      this.$refs['modal-payment'].show()
    },
    showModalPartial() {
      this.selectedPaymentMethod = null
      this.paymentDate = moment(new Date()).format('YYYY-MM-DD')
      this.numPeriods = []
      this.selected.forEach(x => {
        this.numPeriods.push(1)
      })
      this.transferNo = ''
      this.$refs['modal-payment-partial'].show()
    },
    showModalFuture() {
      this.selectedPaymentMethod = null
      this.paymentDate = moment(new Date()).format('YYYY-MM-DD')
      this.numPeriods = []
      this.allConcesions.forEach(x => {
        this.numPeriods.push(1)
      })
      this.transferNo = ''
      this.$refs['modal-payment-future'].show()
    },
    validateMaxPeriods(max, index, origin) {
      var value = this.numPeriods[index]
      let result = true
      if (value > max || value < 1) {
        result = false
      }
      if (value === undefined || this.numPeriods.filter(x => x === undefined).length > 0) {
        this.validNumPayments = false
      } else {
        this.validNumPayments = true
      }
      let total = 0
      if (origin === 1) {
        total = this.numPeriods.reduce((a, b) => parseInt(a) + parseInt(b), 0)
      } else {
        const arr = this.selectedConcesionsObj.map(c => {
          return parseInt(this.numPeriods[c.index])
        })
        console.log(arr)
        total = arr.reduce((a, b) => parseInt(a) + parseInt(b), 0)
      }
      this.totalNumberPaid = total
      console.log('Total: ' + total)
      return result
    },
    changePaymentDate(event) {
      this.paymentDate = event ? moment(new Date(event._d)).format('YYYY-MM-DD') : ''
    },
    totalAmountModal() {
      this.totalAmountModalP = this.totalNumberPaid * 269
      return this.totalAmountModalP
    },
    payConcessions() {
      this.pagando = true
      this.$apollo.query({
        query: GET_AUTH_PAYMENTS,
        context: headers(),
        variables: {
          rfc: this.$store.state.user.rfc,
        },
      }).then(({ data }) => {
        this.allowedToPay = !data.getAuthPayments.pendingPayments
        if (this.allowedToPay) {
          const paymentResume = {
            concesionario: {
              rfc: this.selectedObject[0].pk,
              name: this.$route.params.name,
              email: this.$route.params.email,
              phoneNumber: this.$route.params.phoneNumber,
            },
            totalAmount: this.total(),
            concesiones: this.selectedObject.map(c => {
              return {
                concesionNumber: c.numConcesion,
                periodos: c.periodos,
                amount: c.amount,
              }
            }),
            timestamp: new Date().toISOString(),
            address: this.concesionario.address,
          }
          //
          if (this.selectedPaymentMethod === 'CARD') {
            this.generateCard(paymentResume)
          } else if (this.selectedPaymentMethod === 'OXXO') {
            this.generateOxxoPayment(paymentResume)
          } else if (this.selectedPaymentMethod === 'CASH') {
            try {
              delete this.concesionario.address.__typename
              delete this.concesionario.address.id
              this.$apollo.mutate({
                mutation: GENERATE_CASH_PAYMENT,
                context: headers(),
                variables: {
                  paymentCashInput: paymentResume,
                },
              }).then(data => {
                paymentResume.concesiones.map(concesion => {
                  this.$apollo.mutate({
                    mutation: ACTIVATE_PAID_CONCESION,
                    context: headers(),
                    variables: {
                      concesionNumber: concesion.concesionNumber,
                    },
                  })
                })
                this.$refs['modal-payment'].hide()
                notification.success({
                  message: 'Éxito',
                  description: 'Se registró el pago ',
                })
                this.$apollo.queries.getPaymentsHistory.refetch()
                this.$apollo.queries.getOrderPayment.refetch()
              }).catch(e => {
                notification.error({
                  message: 'Ocurrió un error interno',
                  description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #311',
                })
                this.pagando = false
                //
                // setTimeout(this.errorMessage = '', 2000)
              })
              this.pagando = false
            } catch (err) {
              console.log('ERROR ==> ', err)
            }
            // RESET VARS
            this.pagando = false
          } else if (this.selectedPaymentMethod === 'CREDIT') {

          } else if (this.selectedPaymentMethod === 'TRANSF' || this.selectedPaymentMethod === 'TB') {
            try {
              if (this.transferNo === '') {
                notification.error({
                  message: 'Datos incompletos',
                  description: 'Debes ingresar los datos correctamente.',
                })
                this.pagando = false
                return
              }
              delete this.concesionario.address.__typename
              delete this.concesionario.address.id
              paymentResume.type = this.selectedPaymentMethod
              paymentResume.idTransaction = this.transferNo
              this.$apollo.mutate({
                mutation: GENERATE_TRANSFER_PAYMENT,
                context: headers(),
                variables: {
                  paymentTransferInput: paymentResume,
                },
              }).then(data => {
                paymentResume.concesiones.map(concesion => {
                  this.$apollo.mutate({
                    mutation: ACTIVATE_PAID_CONCESION,
                    context: headers(),
                    variables: {
                      concesionNumber: concesion.concesionNumber,
                    },
                  })
                })
                this.transferNo = ''
                this.$refs['modal-payment'].hide()
                notification.success({
                  message: 'Éxito',
                  description: 'Se registró el pago ',
                })
                this.$apollo.queries.getPaymentsHistory.refetch()
                this.$apollo.queries.getOrderPayment.refetch()
              }).catch(e => {
                notification.error({
                  message: 'Ocurrió un error interno',
                  description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #313',
                })
                this.transferNo = ''
                this.pagando = false
              })
              this.pagando = false
            } catch (err) {
              this.transferNo = ''
              console.log('ERROR ==> ', err)
            }
            this.transferNo = ''
            this.pagando = false
          } else if (this.selectedPaymentMethod === 'PAYNET') {
            const payloadTrx = {
              concesiones: this.selectedObject.map(c => {
                return {
                  concesionNumber: c.numConcesion,
                  periodos: c.periodos,
                  amount: c.amount,
                }
              }),
              amount: this.total(),
              rfc: this.selectedObject[0].pk,
              paymentDate: this.paymentDate,
              name: this.$route.params.name,
              email: this.$route.params.email,
              typeTrx: 'PAYNET',
            }
            console.log(' 1 ====')
            console.log(payloadTrx)
            console.log(' 9 ====')
            this.$apollo.mutate({
              mutation: CREATE_TRX,
              context: headers(),
              variables: {
                createTrxInput: payloadTrx,
              },
            }).then(data => {
              console.log(' 2 ====')
              console.log('data.data.paymentsCreateTrx.refNumber ' + data.data.paymentsCreateTrx.refNumber)
              if (data.data.paymentsCreateTrx.refNumber !== null) {
                console.log(' 3 ====')
                const refNumber = data.data.paymentsCreateTrx.refNumber
                delete this.concesionario.address.__typename
                delete this.concesionario.address.id

                const payloadJWT = {
                  refNumber: refNumber,
                  rfc: this.selectedObject[0].pk,
                  address: this.concesionario.address,
                  id: this.concesionario.id,
                  username: this.concesionario.email,
                  phoneNumber: this.concesionario.phoneNumber,
                }
                this.$apollo.mutate({
                  mutation: CREATE_SUBSCRIBE,
                  context: headers(),
                  variables: {
                    oPSubscribeInput: payloadJWT,
                  },
                }).then(data => {
                  console.log('4 =======')
                  console.log(data)
                  if (data.data.openpaySubscribe.JWT !== null) {
                    const jwt = data.data.openpaySubscribe.jwt
                    console.log('Se genera jwt ' + jwt)
                    this.pagoOpenPay(jwt)
                  }
                }).catch(e => {
                  notification.error({
                    message: 'Ocurrió un error interno',
                    description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #312',
                  })
                  this.pagando = false
                })
              }
            }).catch(e => {
              notification.error({
                message: 'Ocurrió un error interno',
                description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #311',
              })
              this.pagando = false
            })
          }
        } else {
          this.pagando = false
          alert('Tienes pagos pendientes por favor espera a que concluyan')
        }
      }).catch(e => {
        notification.error({
          message: 'Ocurrió un error interno',
          description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #319',
        })
        this.pagando = false
      })
    },
    pagosParciales(origin) {
      this.pagando = true
      if ((this.selectedPaymentMethod === 'TB' ||
      this.selectedPaymentMethod === 'TRANSF'
      ) && this.transferNo === '') {
        notification.error({
          message: 'Datos incompletos',
          description: 'Debes ingresar los datos correctamente.',
        })
        this.pagando = false
        return
      }
      console.log('origin: ', origin)
      let count = 0
      let concesions = []
      if (origin === 1) {
        concesions = this.selectedObject.map(c => {
          return {
            concesionNumber: c.numConcesion,
            numPayments: parseInt(this.numPeriods[count++]),
          }
        })
      } else {
        concesions = this.selectedConcesionsObj.map(c => {
          return {
            concesionNumber: c.concesionNumber,
            numPayments: parseInt(this.numPeriods[c.index]),
          }
        })
      }
      console.log(this.paymentDate)
      const payload = {
        rfc: this.$route.params.rfc,
        paymentMethod: this.selectedPaymentMethod,
        concesions: concesions,
        systemUser: this.$store.state.user.email,
        paymentDate: this.paymentDate,
        name: this.$route.params.name,
        email: this.$route.params.email,
      }
      console.log(payload)
      try {
        this.$apollo.mutate({
          mutation: PAID_BY_PERIOD,
          context: headers(),
          variables: {
            paymentPeriodInput: payload,
          },
        }).then(data => {
          console.log('data.data.paidByPeriod.transaction')
          console.log(data.data.paidByPeriod.transaction)
          if (data.data.paidByPeriod.transaction !== null) {
            console.log('====> #201 ')
            data.data.paidByPeriod.transaction.concesiones.forEach(function(v) {
              delete v.__typename
            })
            const pBPTransaction = data.data.paidByPeriod.transaction
            const paymentResume = {
              concesionario: {
                rfc: this.$route.params.rfc,
                name: this.$route.params.name,
                email: this.$route.params.email,
                phoneNumber: this.$route.params.phoneNumber,
              },
              totalAmount: pBPTransaction.amount,
              concesiones: pBPTransaction.concesiones,
              timestamp: new Date().toISOString(),
              address: this.concesionario.address,
            }
            if (this.selectedPaymentMethod === 'CARD') {
              this.generateCard(paymentResume)
            } else if (this.selectedPaymentMethod === 'OXXO') {
              this.generateOxxoPayment(paymentResume)
            }
            if (this.selectedPaymentMethod === 'PAYNET') {
              console.log('====> #202')
              const payloadTrx = {
                concesiones: pBPTransaction.concesiones,
                amount: pBPTransaction.amount,
                rfc: pBPTransaction.rfc,
                paymentDate: pBPTransaction.paymentDate,
                name: this.$route.params.name,
                email: this.$route.params.email,
                typeTrx: this.selectedPaymentMethod,
              }
              this.$apollo.mutate({
                mutation: CREATE_TRX,
                context: headers(),
                variables: {
                  createTrxInput: payloadTrx,
                },
              }).then(data => {
                console.log('====> #203')
                if (data.data.paymentsCreateTrx.refNumber !== null) {
                  console.log('====> #204')
                  const refNumber = data.data.paymentsCreateTrx.refNumber
                  delete this.concesionario.address.__typename
                  delete this.concesionario.address.id

                  const payloadJWT = {
                    refNumber: refNumber,
                    rfc: pBPTransaction.rfc,
                    address: this.concesionario.address,
                    id: this.concesionario.id,
                    username: this.concesionario.email,
                    phoneNumber: this.concesionario.phoneNumber,
                  }
                  this.$apollo.mutate({
                    mutation: CREATE_SUBSCRIBE,
                    context: headers(),
                    variables: {
                      oPSubscribeInput: payloadJWT,
                    },
                  }).then(data => {
                    console.log('====> #205')
                    if (data.data.openpaySubscribe.JWT !== null) {
                      const jwt = data.data.openpaySubscribe.jwt
                      console.log('====> #206')
                      this.pagoOpenPay(jwt)
                    }
                  }).catch(e => {
                    notification.error({
                      message: 'Ocurrió un error interno',
                      description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #318',
                    })
                    this.pagando = false
                  })
                }
              }).catch(e => {
                notification.error({
                  message: 'Ocurrió un error interno',
                  description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #317',
                })
                this.pagando = false
              })
            }
          } else {
            notification.success({
              message: 'Éxito',
              description: 'Se registró el pago',
            })
            this.refetchVariables()
          }
        }).catch(e => {
          notification.error({
            message: 'Ocurrió un error interno',
            description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #316',
          })
          this.pagando = false
        })
      } catch (err) {
        console.log('ERROR ==> ', err)
        this.pagando = false
      }
    }, // Termina
    async pagoOpenPay(jwt) {
      console.log('====> #207')
      const openPayApiUrl = config[process.env.NODE_ENV].openPayApi
      const con = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      axios.get(`${openPayApiUrl}/api/v1/admins/generate_paynet?jwt=${jwt}`, con)
        .then(result => {
          console.log('====> #208')
          window.open(result.data.urlPaynet, '_blank')
          notification.success({
            message: 'Éxito',
            description: 'Se generó correctamente la orden de pago ',
          })
          this.pagando = false
          this.refetchVariables()
        })
        .catch(error => {
          this.pagando = false
          console.log(error)
        })
    },
    refetchVariables() {
      this.$refs['modal-payment-partial'].hide()
      this.$refs['modal-payment-future'].hide()
      this.selected = []
      this.selectedObject = []
      this.$apollo.queries.getPaymentsHistory.refetch()
      this.$apollo.queries.getOrderPayment.refetch()
      this.pagando = false
      this.$refs['modal-payment'].hide()
      this.transferNo = ''
      this.selectedConcesions = []
      this.selectedConcesionsObj = []
    },
    generateOxxoPayment(payload) {
      delete this.concesionario.address.__typename
      delete this.concesionario.address.id
      this.$apollo.mutate({
        mutation: GENERATE_OXXO_PAYMENT,
        context: headers(),
        variables: {
          paymentOxxoSubInput: payload,
        },
      }).then(data => {
        window.open(data.data.generateOxxoPaymentSub.paymentURL, '_blank')
        this.pagando = false
        this.$refs['modal-payment'].hide()
        notification.success({
          message: 'Éxito',
          description: 'Se generó la orden de compra ',
        })
        this.refetchVariables()
      }).catch(e => {
        console.log(e)
        notification.error({
          message: 'Ocurrió un error interno',
          description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador. Error #314',
        })
        this.pagando = false
      })
    },
    generateCard(payload) {
      console.log('sectrets => ', secrets)
      // secrets.retrieveSecretCybersource().then(s => {
      console.log('ENTER => ')
      // const secretKey = JSON.parse(s).secret_key
      const secretKey = '6cb5e758314b4d948a844d62139776ee20fb0e0cd6ed4fcbb1714f9510014ba7e5e92d8e0140475e8e0c6e40c8c0c776873c8db582b14e37b7feb1b66c629d683b8e4afa99d44bcc964df7c355683511b401b6ee59314397bef1adb3412856b0f0efced97a374631b94854a10bfc1487b467b1e62cd44382a76bc47a06ceecee'
      const paymentString = JSON.stringify(payload)
      console.log('paymentString => ', paymentString)
      const encryptedPaymentDetails = crypto.AES.encrypt(paymentString, secretKey).toString()
      console.log('encryptedPaymentDetails => ', encryptedPaymentDetails)
      const urlService = `${config[process.env.NODE_ENV].securePayment}paymentConfirmation?payment=${encryptedPaymentDetails}`
      console.log('urlService => ', urlService)
      window.location = urlService
      // }).catch(e => {
      // console.log(e)
      // notification.error({
      // message: 'Ocurrió un error interno',
      // description: 'Por favor intenta de nuevo, si el problema persiste contacta al administrador.',
      // })
      // this.pagando = false
      // })
    },
  },
}
</script>
<style scoped>
</style>
